import { render, staticRenderFns } from "./AI-image.vue?vue&type=template&id=5c7a4792&scoped=true&"
import script from "./AI-image.ts?vue&type=script&lang=js&"
export * from "./AI-image.ts?vue&type=script&lang=js&"
import style0 from "./AI-image.less?vue&type=style&index=0&id=5c7a4792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7a4792",
  null
  
)

export default component.exports